import React, { Component } from "react";
import Draggable from "react-draggable";
import { inArray, l } from "../functions";
import Icon from "./Icons";
import SliderRange from "./SliderRange";

export class HoverSpacer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFields: {},
    };
  }
  _setSelectedField = (type, target, field, defaultValue = 0) => {
    const fields =
      (this.state.selectedFields && this.state.selectedFields[target]) || [];
    let finalFields = [];

    if (inArray(field, fields)) {
      fields.forEach((ifield) => {
        if (ifield !== field) finalFields.push(ifield);
      });
    } else {
      fields.push(field);
      finalFields = fields;
    }

    let finalFieldsValue = 0;
    if (finalFields.length > 0) {
      finalFieldsValue =
        (this.state[type] &&
          this.state[type][target] &&
          this.state[type][target][finalFields[0]]) ||
        defaultValue ||
        0;

      finalFields.forEach((jfield) => {
        if (
          this.state[type] &&
          this.state[type][target] &&
          finalFieldsValue !== this.state[type][target][jfield]
        )
          finalFieldsValue = 0;
      });
    }

    this.setState({
      ...this.state,
      selectedFields: {
        ...this.state.selectedFields,
        [target]: finalFields,
      },
      selectedFieldsValue: {
        ...this.state.selectedFieldsValue,
        [target]: finalFieldsValue,
      },
    });
  };

  _changedSettingsTwo = (...args) => {
    this.props.onChange(...args);
  };

  _generateOption = () => {
    const { spacingSettings, hoverBar, open = true } = this.props;
    return (
      <div className="section">
        <div className="spacing-area">
          <div className="top">
            <div>
              <input
                type="text"
                readOnly
                onClick={() => {
                  this._setSelectedField(
                    "settings",
                    "spacing",
                    "marginTop",
                    (spacingSettings && spacingSettings.marginTop) || 0
                  );
                }}
                className={
                  this.state.selectedFields.spacing &&
                  inArray("marginTop", this.state.selectedFields.spacing)
                    ? "active"
                    : ""
                }
                value={(spacingSettings && spacingSettings.marginTop) || 0}
              />
            </div>
          </div>
          <div className="middle">
            <div>
              <input
                type="text"
                readOnly
                onClick={() => {
                  this._setSelectedField(
                    "settings",
                    "spacing",
                    "marginLeft",
                    (spacingSettings && spacingSettings.marginLeft) || 0
                  );
                }}
                className={
                  this.state.selectedFields.spacing &&
                  inArray("marginLeft", this.state.selectedFields.spacing)
                    ? "active"
                    : ""
                }
                value={(spacingSettings && spacingSettings.marginLeft) || 0}
              />
            </div>
            <div>
              <div>
                <span className="padding">{l("Padding")}</span>
                <input
                  type="text"
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      "settings",
                      "spacing",
                      "paddingLeft",
                      (spacingSettings && spacingSettings.paddingLeft) || 0
                    );
                  }}
                  className={
                    this.state.selectedFields.spacing &&
                    inArray("paddingLeft", this.state.selectedFields.spacing)
                      ? "active"
                      : ""
                  }
                  value={(spacingSettings && spacingSettings.paddingLeft) || 0}
                />
              </div>
              <div>
                <div>
                  <input
                    type="text"
                    readOnly
                    onClick={() => {
                      this._setSelectedField(
                        "settings",
                        "spacing",
                        "paddingTop",
                        (spacingSettings && spacingSettings.paddingTop) || 0
                      );
                    }}
                    className={
                      this.state.selectedFields.spacing &&
                      inArray("paddingTop", this.state.selectedFields.spacing)
                        ? "active"
                        : ""
                    }
                    value={(spacingSettings && spacingSettings.paddingTop) || 0}
                  />
                </div>
                <div></div>
                <div>
                  <input
                    type="text"
                    readOnly
                    onClick={() => {
                      this._setSelectedField(
                        "settings",
                        "spacing",
                        "paddingBottom",
                        (spacingSettings && spacingSettings.paddingBottom) || 0
                      );
                    }}
                    className={
                      this.state.selectedFields.spacing &&
                      inArray(
                        "paddingBottom",
                        this.state.selectedFields.spacing
                      )
                        ? "active"
                        : ""
                    }
                    value={
                      (spacingSettings && spacingSettings.paddingBottom) || 0
                    }
                  />
                </div>
              </div>
              <div>
                <input
                  type="text"
                  readOnly
                  onClick={() => {
                    this._setSelectedField(
                      "settings",
                      "spacing",
                      "paddingRight",
                      (spacingSettings && spacingSettings.paddingRight) || 0
                    );
                  }}
                  className={
                    this.state.selectedFields.spacing &&
                    inArray("paddingRight", this.state.selectedFields.spacing)
                      ? "active"
                      : ""
                  }
                  value={(spacingSettings && spacingSettings.paddingRight) || 0}
                />
              </div>
            </div>
            <div>
              <input
                type="text"
                readOnly
                onClick={() => {
                  this._setSelectedField(
                    "settings",
                    "spacing",
                    "marginRight",
                    (spacingSettings && spacingSettings.marginRight) || 0
                  );
                }}
                className={
                  this.state.selectedFields.spacing &&
                  inArray("marginRight", this.state.selectedFields.spacing)
                    ? "active"
                    : ""
                }
                value={(spacingSettings && spacingSettings.marginRight) || 0}
              />
            </div>
          </div>
          <div className="bottom">
            <div>
              <span className="margin">{l("Margin")}</span>
              <input
                type="text"
                readOnly
                onClick={() => {
                  this._setSelectedField(
                    "settings",
                    "spacing",
                    "marginBottom",
                    (spacingSettings && spacingSettings.marginBottom) || 0
                  );
                }}
                className={
                  this.state.selectedFields.spacing &&
                  inArray("marginBottom", this.state.selectedFields.spacing)
                    ? "active"
                    : ""
                }
                value={(spacingSettings && spacingSettings.marginBottom) || 0}
              />
            </div>
          </div>
          <div className="gk-ray a"></div>
          <div className="gk-ray b"></div>
        </div>
        {this.state.selectedFields.spacing &&
          this.state.selectedFields.spacing.length > 0 && (
            <SliderRange
              value={this.state.selectedFieldsValue.spacing || 0}
              min={
                inArray("paddingLeft", this.state.selectedFields.spacing) ||
                inArray("paddingTop", this.state.selectedFields.spacing) ||
                inArray("paddingBottom", this.state.selectedFields.spacing) ||
                inArray("paddingRight", this.state.selectedFields.spacing)
                  ? 0
                  : -300
              }
              max={300}
              onChange={(value) => {
                this._changedSettingsTwo(
                  this.props.item || "spacing",
                  this.state.selectedFields.spacing,
                  value
                );
              }}
            />
          )}
        {this.state.selectedFields.spacing &&
          this.state.selectedFields.spacing.length > 0 &&
          !(
            inArray("paddingLeft", this.state.selectedFields.spacing) ||
            inArray("paddingTop", this.state.selectedFields.spacing) ||
            inArray("paddingBottom", this.state.selectedFields.spacing) ||
            inArray("paddingRight", this.state.selectedFields.spacing)
          ) && (
            <span className="ultrasmall-alert">
              {l("You can set negative value")}
            </span>
          )}
      </div>
    );
  };

  _elementDrag = (e) => {};

  render() {
    const { spacingSettings, hoverBar, open = false } = this.props;
    if (hoverBar) {
      const ran = Math.floor(Math.random() * 100);
      return (
        <>
          <Icon icon={"spacer"} onClick={this.props.onClickIcon} />
          {open && (
            <div
              className="quickbartools body float"
              id={"dragspacerheader" + ran}
            >
              <div className="options">{this._generateOption()}</div>
              <div className="close-options">
                <div
                  id="dragspacer"
                  onMouseDown={(e) => {
                    e = e || window.event;

                    var pos1 = 0,
                      pos2 = 0,
                      pos3 = 0,
                      pos4 = 0;
                    var elmnt = document.getElementById(
                      "dragspacerheader" + ran
                    );

                    dragMouseDown(e);
                    function dragMouseDown(e) {
                      e = e || window.event;
                      e.preventDefault();
                      // get the mouse cursor position at startup:
                      pos3 = e.clientX;
                      pos4 = e.clientY;
                      document.onmouseup = closeDragElement;
                      // call a function whenever the cursor moves:
                      document.onmousemove = elementDrag;
                    }

                    function elementDrag(e) {
                      e = e || window.event;
                      e.preventDefault();
                      // calculate the new cursor position:
                      pos1 = pos3 - e.clientX;
                      pos2 = pos4 - e.clientY;
                      pos3 = e.clientX;
                      pos4 = e.clientY;
                      // set the element's new position:
                      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
                      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
                    }

                    function closeDragElement() {
                      // stop moving when mouse button is released:

                      document.onmouseup = null;
                      document.onmousemove = null;
                    }
                  }}
                >
                  <Icon icon={"grip"} />
                </div>
                <Icon icon={"time"} onClick={this.props.onClickIcon} />
              </div>
            </div>
          )}
        </>
      );
    } else {
      return this._generateOption();
    }
  }
}

export default HoverSpacer;
